import React from 'react';
import PropTypes from 'prop-types';
import { IconWrapper } from './styles';
import Briefcase from 'components/ui/icons/Briefcase';

const ProjectCompany = ({ briefDescription }) => {
  return (
    <>
      {briefDescription && (
        <div className="mb-2 d-flex">
          <IconWrapper>
            <Briefcase width="15" />
          </IconWrapper>
          <div>{briefDescription}</div>
        </div>
      )}
    </>
  );
};

ProjectCompany.propTypes = {
  briefDescription: PropTypes.string,
};

export default ProjectCompany;
